import { render } from "./SmsTemplatesIndexPage.vue?vue&type=template&id=649898c5"
import script from "./SmsTemplatesIndexPage.vue?vue&type=script&lang=js"
export * from "./SmsTemplatesIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__